export default "__VITE_ASSET__74Tq9VOb__"